var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgHamburgerMobile = function SvgHamburgerMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 6a1.2 1.2 0 011.2-1.2h14.4a1.2 1.2 0 010 2.4H4.8A1.2 1.2 0 013.6 6zm0 6a1.2 1.2 0 011.2-1.2h14.4a1.2 1.2 0 110 2.4H4.8A1.2 1.2 0 013.6 12zm.351 5.151A1.2 1.2 0 004.8 19.2h14.4a1.2 1.2 0 100-2.4H4.8a1.2 1.2 0 00-.849.351z",
    fill: "#9CA6AD"
  })));
};

export default SvgHamburgerMobile;